import React, { useMemo } from "react";
import { JsonBox } from "../Styled";

const safeStringify = (data: any) => {
    try {
        return JSON.stringify(data, null, 2);
    } catch {
        return String(data);
    }
};

const JsonView: React.FC<{ data: any; borderLeftColor?: string }> = ({
    data,
    borderLeftColor,
}) => {
    const text = useMemo(() => safeStringify(data), [data]);
    return <JsonBox borderLeftColor={borderLeftColor}>{text}</JsonBox>;
};

export default JsonView;


